"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerNavItem = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var DrawerContext_1 = require("./DrawerContext");
var NavGroupContext_1 = require("./NavGroupContext");
var usePrevious_1 = require("../hooks/usePrevious");
var core_1 = require("@material-ui/core");
var InfoListItem_1 = require("../InfoListItem");
var ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
var ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var types_1 = require("./types");
var clsx_1 = __importDefault(require("clsx"));
var color_1 = __importDefault(require("color"));
var utilities_1 = require("./utilities");
var colors_1 = require("@pxblue/colors");
// First nested item has no additional indentation.  All items start with 16px indentation.
var calcNestedPadding = function (theme, depth) {
    return theme.spacing(depth ? (depth - 1) * 4 : 0) + theme.spacing(2);
};
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        active: {
            content: '""',
            zIndex: 0,
            position: 'absolute',
            height: '100%',
            width: "calc(100% - " + theme.spacing(1) + "px)",
            left: 0,
            top: 0,
            borderRadius: "0px 1.625rem 1.625rem 0px",
            opacity: 0.9,
            '&$square': {
                width: '100%',
                borderRadius: 0,
            },
        },
        drawerOpen: {},
        expanded: {},
        expandIcon: {
            transitionDuration: theme.transitions.duration.standard + "ms",
            cursor: 'inherit',
            display: 'flex',
            padding: '1rem',
            marginRight: '-1rem',
            alignItems: 'center',
            justifyContent: 'center',
            '&$expanded': {
                transform: 'rotate(180deg)',
            },
        },
        infoListItemRoot: {
            // Have to specify both of these. JSS doesn't like to automatically flip the rule when it's calculated from a function
            paddingLeft: function (props) {
                return theme.direction === 'rtl' ? theme.spacing(2) : calcNestedPadding(theme, props.depth);
            },
            paddingRight: function (props) {
                return theme.direction === 'ltr' ? theme.spacing(2) : calcNestedPadding(theme, props.depth);
            },
        },
        nestedTitle: {
            fontWeight: 400,
        },
        nestedListGroup: {
            backgroundColor: function (props) {
                return props.nestedBackgroundColor || (theme.palette.type === 'light' ? colors_1.white[200] : colors_1.darkBlack[500]);
            },
            paddingBottom: 0,
            paddingTop: 0,
        },
        noIconTitle: {
            opacity: 0,
            transition: theme.transitions.create('opacity'),
            '&$drawerOpen': {
                opacity: 1,
                transition: theme.transitions.create('opacity'),
            },
        },
        ripple: {
            backgroundColor: theme.palette.primary.main,
        },
        root: {
            backgroundColor: function (props) {
                return (props.depth > 0 ? props.nestedBackgroundColor : props.backgroundColor) || 'transparent';
            },
        },
        square: {},
        textSecondary: {
            color: theme.palette.type === 'dark' ? theme.palette.text.secondary : undefined,
        },
        title: {
            fontWeight: 400,
        },
        titleActive: {
            fontWeight: 600,
        },
        flipIcon: theme.direction === 'rtl'
            ? {
                transform: 'scaleX(-1)',
            }
            : {},
    });
});
var DrawerNavItemRender = function (props, ref) {
    var _a, _b, _c, _d;
    var theme = core_1.useTheme();
    var defaultClasses = useStyles(props);
    var _e = DrawerContext_1.useDrawerContext(), _f = _e.open, drawerOpen = _f === void 0 ? true : _f, activeItem = _e.activeItem, onItemSelect = _e.onItemSelect;
    var activeHierarchy = NavGroupContext_1.useNavGroupContext().activeHierarchy;
    var previousActive = usePrevious_1.usePrevious(activeItem);
    // Primary color manipulation
    var fivePercentOpacityPrimary = color_1.default(theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main)
        .fade(0.95)
        .string();
    var twentyPercentOpacityPrimary = color_1.default(theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main)
        .fade(0.8)
        .string();
    // approximating primary[200] but we don't have access to it directly from the theme
    var lightenedPrimary = color_1.default(theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main)
        .lighten(0.83)
        .desaturate(0.39)
        .string();
    // Destructure the props
    var _g = props.activeItemBackgroundColor, activeItemBackgroundColor = _g === void 0 ? theme.palette.type === 'light'
        ? fivePercentOpacityPrimary
        : twentyPercentOpacityPrimary : _g, _h = props.activeItemBackgroundShape, activeItemBackgroundShape = _h === void 0 ? 'square' : _h, _j = props.activeItemFontColor, activeItemFontColor = _j === void 0 ? theme.palette.type === 'light' ? theme.palette.primary.main : lightenedPrimary : _j, _k = props.activeItemIconColor, activeItemIconColor = _k === void 0 ? theme.palette.type === 'light' ? theme.palette.primary.main : lightenedPrimary : _k, backgroundColor = props.backgroundColor, chevron = props.chevron, children = props.children, _l = props.classes, classes = _l === void 0 ? {} : _l, collapseIcon = props.collapseIcon, _m = props.depth, depth = _m === void 0 ? 0 : _m, _o = props.disableActiveItemParentStyles, disableActiveItemParentStyles = _o === void 0 ? false : _o, divider = props.divider, _p = props.expandIcon, expandIcon = _p === void 0 ? props.depth ? react_1.default.createElement(ArrowDropDown_1.default, null) : react_1.default.createElement(ExpandMore_1.default, null) : _p, hidePadding = props.hidePadding, itemIcon = props.icon, _q = props.InfoListItemProps, InfoListItemProps = _q === void 0 ? {} : _q, isInActiveTree = props.isInActiveTree, itemID = props.itemID, _r = props.itemFontColor, itemFontColor = _r === void 0 ? theme.palette.text.primary : _r, _s = props.itemIconColor, itemIconColor = _s === void 0 ? theme.palette.text.primary : _s, items = props.items, nestedBackgroundColor = props.nestedBackgroundColor, nestedDivider = props.nestedDivider, _t = props.notifyActiveParent, notifyActiveParent = _t === void 0 ? function () { } : _t, onClick = props.onClick, _u = props.rightComponent, rightComponent = _u === void 0 ? props.chevron && !props.items && !props.children ? (react_1.default.createElement(ChevronRight_1.default, { className: defaultClasses.flipIcon })) : undefined : _u, _v = props.ripple, ripple = _v === void 0 ? true : _v, statusColor = props.statusColor, itemSubtitle = props.subtitle, itemTitle = props.title;
    var _w = react_1.useState(isInActiveTree), expanded = _w[0], setExpanded = _w[1];
    var active = activeItem === itemID;
    var hasAction = Boolean(onItemSelect || onClick || (items && items.length > 0) || Boolean(children));
    // only allow icons for the top level items
    var icon = !depth ? itemIcon : undefined;
    var showDivider = depth > 0 ? (nestedDivider !== undefined ? nestedDivider : false) : divider !== undefined ? divider : false;
    // When the activeItem changes, update our expanded state
    react_1.useEffect(function () {
        if (isInActiveTree && !expanded) {
            setExpanded(true);
        }
    }, [isInActiveTree]); // Only update if the active tree changes (not after manual expand/collapse action)
    // If the active item changes
    react_1.useEffect(function () {
        if (activeItem === itemID && previousActive !== itemID) {
            // notify the parent that it should now be in the active tree
            notifyActiveParent([itemID]);
        }
    }, [activeItem, notifyActiveParent]);
    // Customize the color of the Touch Ripple
    var RippleProps = ripple && hasAction
        ? {
            TouchRippleProps: {
                classes: {
                    child: clsx_1.default(defaultClasses.ripple, classes.ripple),
                },
            },
        }
        : {};
    // Handle click callbacks
    var onClickAction = react_1.useCallback(function (e) {
        if (onItemSelect) {
            onItemSelect(itemID);
        }
        if (onClick) {
            onClick(e);
        }
        else if ((items && items.length > 0) || Boolean(children)) {
            setExpanded(!expanded);
        }
    }, [onItemSelect, onClick, itemID, items, expanded, setExpanded]);
    var getActionComponent = react_1.useCallback(function () {
        var _a;
        if (!items && !children) {
            return null;
        }
        return (react_1.default.createElement("div", { onClick: function (e) {
                if (e) {
                    setExpanded(!expanded);
                    e.stopPropagation();
                }
            }, className: clsx_1.default(defaultClasses.expandIcon, classes.expandIcon, (_a = {},
                _a[defaultClasses.expanded] = !collapseIcon && expanded,
                _a)) }, collapseIcon && expanded ? collapseIcon : expandIcon));
    }, [items, children, classes, defaultClasses, collapseIcon, expanded, expandIcon]);
    var actionComponent = getActionComponent();
    var getChildren = react_1.useCallback(function () {
        return utilities_1.findChildByType(children, ['DrawerNavItem', 'DrawerRailItem'])
            // .slice(0, 1)
            .map(function (child) {
            return child.type.displayName === 'DrawerNavItem'
                ? react_1.default.cloneElement(child, {
                    // Inherited Props
                    activeItemBackgroundColor: utilities_1.mergeStyleProp(activeItemBackgroundColor, child.props.activeItemBackgroundColor),
                    activeItemBackgroundShape: utilities_1.mergeStyleProp(activeItemBackgroundShape, child.props.activeItemBackgroundShape),
                    activeItemFontColor: utilities_1.mergeStyleProp(activeItemFontColor, child.props.activeItemFontColor),
                    activeItemIconColor: utilities_1.mergeStyleProp(activeItemIconColor, child.props.activeItemIconColor),
                    backgroundColor: utilities_1.mergeStyleProp(backgroundColor, child.props.backgroundColor),
                    chevron: utilities_1.mergeStyleProp(chevron, child.props.chevron),
                    // we use props. because we don't want to pass the destructured default as the value to children
                    collapseIcon: utilities_1.mergeStyleProp(props.collapseIcon, child.props.collapseIcon),
                    disableActiveItemParentStyles: utilities_1.mergeStyleProp(disableActiveItemParentStyles, child.props.disableActiveItemParentStyles),
                    divider: utilities_1.mergeStyleProp(divider, child.props.divider),
                    // we use props. because we don't want to pass the destructured default as the value to children
                    expandIcon: utilities_1.mergeStyleProp(props.expandIcon, child.props.expandIcon),
                    hidePadding: utilities_1.mergeStyleProp(hidePadding, child.props.hidePadding),
                    itemFontColor: utilities_1.mergeStyleProp(itemFontColor, child.props.itemFontColor),
                    itemIconColor: utilities_1.mergeStyleProp(itemIconColor, child.props.itemIconColor),
                    nestedBackgroundColor: utilities_1.mergeStyleProp(nestedBackgroundColor, child.props.nestedBackgroundColor),
                    nestedDivider: utilities_1.mergeStyleProp(nestedDivider, child.props.nestedDivider),
                    ripple: utilities_1.mergeStyleProp(ripple, child.props.ripple),
                    depth: depth + 1,
                    isInActiveTree: activeHierarchy.includes(child.props.itemID),
                    notifyActiveParent: function (ids) {
                        if (ids === void 0) { ids = []; }
                        notifyActiveParent(ids.concat(itemID));
                    },
                })
                : react_1.default.cloneElement(child, {
                    // Inherited Props
                    activeItemBackgroundColor: utilities_1.mergeStyleProp(activeItemBackgroundColor, child.props.activeItemBackgroundColor),
                    activeItemFontColor: utilities_1.mergeStyleProp(activeItemFontColor, child.props.activeItemFontColor),
                    activeItemIconColor: utilities_1.mergeStyleProp(activeItemIconColor, child.props.activeItemIconColor),
                    backgroundColor: utilities_1.mergeStyleProp(backgroundColor, child.props.backgroundColor),
                    divider: utilities_1.mergeStyleProp(divider, child.props.divider),
                    itemFontColor: utilities_1.mergeStyleProp(itemFontColor, child.props.itemFontColor),
                    itemIconColor: utilities_1.mergeStyleProp(itemIconColor, child.props.itemIconColor),
                    ripple: utilities_1.mergeStyleProp(ripple, child.props.ripple),
                });
        });
    }, [
        activeItemBackgroundColor,
        activeItemBackgroundShape,
        activeItemFontColor,
        activeItemIconColor,
        activeHierarchy,
        backgroundColor,
        chevron,
        collapseIcon,
        disableActiveItemParentStyles,
        divider,
        expandIcon,
        hidePadding,
        itemFontColor,
        itemIconColor,
        nestedBackgroundColor,
        nestedDivider,
        notifyActiveParent,
        ripple,
        children,
    ]);
    // Combine the classes to pass down the the InfoListItem
    var infoListItemClasses = {
        root: clsx_1.default(defaultClasses.infoListItemRoot, classes.infoListItemRoot),
        title: clsx_1.default(defaultClasses.title, classes.title, (_a = {},
            _a[defaultClasses.titleActive] = active || (!disableActiveItemParentStyles && isInActiveTree),
            _a[classes.titleActive] = (active || (!disableActiveItemParentStyles && isInActiveTree)) && classes.titleActive,
            _a[defaultClasses.nestedTitle] = depth > 0,
            _a[classes.nestedTitle] = depth > 0 && classes.nestedTitle,
            _a[defaultClasses.noIconTitle] = hidePadding && !icon,
            _a[defaultClasses.drawerOpen] = drawerOpen,
            _a)),
        subtitle: clsx_1.default((_b = {},
            _b[defaultClasses.textSecondary] = !active,
            _b[defaultClasses.noIconTitle] = hidePadding && !icon,
            _b[defaultClasses.drawerOpen] = drawerOpen,
            _b)),
        info: clsx_1.default((_c = {},
            _c[defaultClasses.textSecondary] = !active,
            _c)),
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !props.hidden && (react_1.default.createElement("div", { ref: ref, style: { position: 'relative' }, className: clsx_1.default(defaultClasses.root, classes.root) },
            active && (react_1.default.createElement("div", { className: clsx_1.default(defaultClasses.active, classes.active, (_d = {},
                    _d[defaultClasses.square] = activeItemBackgroundShape === 'square',
                    _d)), style: { backgroundColor: activeItemBackgroundColor } })),
            react_1.default.createElement(InfoListItem_1.InfoListItem, __assign({ dense: true, title: itemTitle, subtitle: itemSubtitle, divider: showDivider ? 'full' : undefined, statusColor: statusColor, fontColor: active ? activeItemFontColor : itemFontColor, icon: icon, iconColor: active ? activeItemIconColor : itemIconColor, rightComponent: (actionComponent || rightComponent) && (react_1.default.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        color: active ? activeItemIconColor : itemIconColor,
                    } },
                    rightComponent,
                    actionComponent)), backgroundColor: 'transparent', onClick: hasAction ? onClickAction : undefined, hidePadding: hidePadding, ripple: ripple }, RippleProps, InfoListItemProps, { classes: Object.assign(infoListItemClasses, InfoListItemProps.classes) })))),
        ((items && items.length > 0) || Boolean(children)) && (react_1.default.createElement(core_1.Collapse, { in: expanded && drawerOpen !== false, key: itemTitle + "_group_" + depth },
            react_1.default.createElement(core_1.List, { className: clsx_1.default(defaultClasses.nestedListGroup, classes.nestedListGroup) },
                items &&
                    items.map(function (subItem, index) { return (
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    react_1.default.createElement(exports.DrawerNavItem, __assign({ key: "itemList_" + index }, subItem, { activeItemBackgroundColor: utilities_1.mergeStyleProp(activeItemBackgroundColor, subItem.activeItemBackgroundColor), activeItemBackgroundShape: utilities_1.mergeStyleProp(activeItemBackgroundShape, subItem.activeItemBackgroundShape), activeItemFontColor: utilities_1.mergeStyleProp(activeItemFontColor, subItem.activeItemFontColor), activeItemIconColor: utilities_1.mergeStyleProp(activeItemIconColor, subItem.activeItemIconColor), backgroundColor: utilities_1.mergeStyleProp(backgroundColor, subItem.backgroundColor), chevron: utilities_1.mergeStyleProp(chevron, subItem.chevron), 
                        // we use props. because we don't want to pass the destructured default as the value to the children
                        collapseIcon: utilities_1.mergeStyleProp(props.collapseIcon, subItem.collapseIcon), disableActiveItemParentStyles: utilities_1.mergeStyleProp(disableActiveItemParentStyles, subItem.disableActiveItemParentStyles), divider: utilities_1.mergeStyleProp(divider, subItem.divider), 
                        // we use props. because we don't want to pass the destructured default as the value to the children
                        expandIcon: utilities_1.mergeStyleProp(props.expandIcon, subItem.expandIcon), hidePadding: utilities_1.mergeStyleProp(hidePadding, subItem.hidePadding), itemFontColor: utilities_1.mergeStyleProp(itemFontColor, subItem.itemFontColor), itemIconColor: utilities_1.mergeStyleProp(itemIconColor, subItem.itemIconColor), nestedBackgroundColor: utilities_1.mergeStyleProp(nestedBackgroundColor, subItem.nestedBackgroundColor), nestedDivider: utilities_1.mergeStyleProp(nestedDivider, subItem.nestedDivider), ripple: utilities_1.mergeStyleProp(ripple, subItem.ripple), depth: depth + 1, isInActiveTree: activeHierarchy.includes(subItem.itemID), notifyActiveParent: function (ids) {
                            if (ids === void 0) { ids = []; }
                            notifyActiveParent(ids.concat(itemID));
                        } }))); }),
                getChildren())))));
};
/**
 * [DrawerNavItem](https://pxblue-components.github.io/react/?path=/info/components-drawer--get-read-me-story) component
 *
 * The `<DrawerNavItem>` is an individual line item in the `<Drawer>`. These can be generated for you by using the `items` prop of the `<DrawerNavGroup>` and passing in an array of objects with the following API. You can also create these line items by directly passing them as children to the `<DrawerNavGroup>`. Each `<DrawerNavItem>` also supports the ability to nest items (using its own `items` prop or children). When using the rail variant of the `<Drawer>`, you should use `<DrawerRailItem>` instead.
 */
exports.DrawerNavItem = react_1.default.forwardRef(DrawerNavItemRender);
exports.DrawerNavItem.displayName = 'DrawerNavItem';
exports.DrawerNavItem.propTypes = __assign(__assign(__assign({}, types_1.SharedStylePropTypes), types_1.NavItemSharedStylePropTypes), { classes: prop_types_1.default.shape({
        active: prop_types_1.default.string,
        expandIcon: prop_types_1.default.string,
        infoListItemRoot: prop_types_1.default.string,
        nestedListGroup: prop_types_1.default.string,
        nestedTitle: prop_types_1.default.string,
        ripple: prop_types_1.default.string,
        root: prop_types_1.default.string,
        title: prop_types_1.default.string,
        titleActive: prop_types_1.default.string,
    }), depth: prop_types_1.default.number, hidden: prop_types_1.default.bool, hidePadding: prop_types_1.default.bool, icon: prop_types_1.default.element, isInActiveTree: prop_types_1.default.bool, itemID: prop_types_1.default.string.isRequired, 
    // @ts-ignore
    items: prop_types_1.default.arrayOf(prop_types_1.default.shape(__assign(__assign(__assign({}, types_1.SharedStylePropTypes), types_1.NavItemSharedStylePropTypes), { itemID: prop_types_1.default.string.isRequired, subtitle: prop_types_1.default.string, title: prop_types_1.default.string.isRequired, onClick: prop_types_1.default.func, rightComponent: prop_types_1.default.element, statusColor: prop_types_1.default.string }))), notifyActiveParent: prop_types_1.default.func, onClick: prop_types_1.default.func, rightComponent: prop_types_1.default.element, statusColor: prop_types_1.default.string, subtitle: prop_types_1.default.string, title: prop_types_1.default.string.isRequired, InfoListItemProps: prop_types_1.default.object });
